import {
    TAGS_OPEN_CREATE_EDIT_MODAL,
    TAGS_SAVE_TAG,
    TAGS_SAVE_TAG_RESPONSE,
    TAGS_GET_TAG,
    TAGS_GET_TAG_RESPONSE,
    TAGS_GET_ENTITIES,
    TAGS_GET_ENTITIES_RESPONSE
} from "Redux/actionTypes";

export const tagsOpenCreateEdit = (open, id, disabledEntities = false) => {
    return {
        type: TAGS_OPEN_CREATE_EDIT_MODAL,
        payload: { open, id, disabledEntities },
    };
};

export const tagsSaveTag = (tag) => {
    return {
        type: TAGS_SAVE_TAG,
        payload: { tag },
    };
};

export const tagsSaveTagResponse = (data) => {
    return {
        type: TAGS_SAVE_TAG_RESPONSE,
        payload: { data } ,
    };
};

export const tagsGetTag = (id) => {
    return {
        type: TAGS_GET_TAG,
        payload: { id },
    };
};

export const tagsGetTagResponse = (data) => {
    return {
        type: TAGS_GET_TAG_RESPONSE,
        payload: { data },
    };
};

export const tagsGetEntities = (data) => {
    return {
        type: TAGS_GET_ENTITIES,
        payload: { data },
    };
};

export const tagsGetEntitiesResponse = (response) => {
    return {
        type: TAGS_GET_ENTITIES_RESPONSE,
        payload: { response },
    };
};